import React from 'react';
import { cn } from '@/lib/utils';
import { useNavigationItem } from '@/hooks/useNavigationItem';

interface PageTitleProps {
  title: string;
  className?: string;
}

export function PageTitle({ title, className }: PageTitleProps) {
  const { activeItem } = useNavigationItem();

  // Get the color from the active navigation item
  const titleColorStyle = React.useMemo(() => {
    if (!activeItem?.color) return {};
    
    // Extract the color from the gradient string
    const colorMatch = activeItem.color.match(/from-\[(.*?)\]/);
    if (colorMatch && colorMatch[1]) {
      return { color: colorMatch[1] };
    }
    
    return {};
  }, [activeItem]);

  return (
    <div className="mb-6">
      <h1 
        className={cn(
          "text-2xl font-semibold transition-colors duration-300",
          className
        )}
        style={titleColorStyle}
      >
        {title}
      </h1>
    </div>
  );
} 